'use client';

import { Package } from 'lucide-react';

interface Props {
  itemName: string;
  price: number;
}

export default function Step1QuotedItemReadonly({ itemName, price }: Props) {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-base font-bold text-gray-900 mb-1">물품 정보</h3>
        <p className="text-sm text-gray-500">견적이 확정된 물품입니다</p>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
            <Package className="w-5 h-5 text-[#1A3A5C]" />
          </div>
          <div>
            <p className="font-semibold text-gray-900">{itemName}</p>
            <p className="text-sm text-[#1A3A5C] font-medium">
              운송비 기본가: {price.toLocaleString()}원
            </p>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
        <p className="text-sm text-gray-500">
          견적 확정 물품은 수정할 수 없습니다. 변경이 필요하시면 새로 견적을 요청해주세요.
        </p>
      </div>
    </div>
  );
}
